import { lazy as yupLazy } from "yup";
import isEqual from "lodash/isEqual";

const predefinedCheckFn = {
  isDefault(value, { defaultValue }) {
    return isEqual(defaultValue, value);
  },
};

export function myIf(checkFnDetails, thenSchema, otherwiseSchema) {
  if (typeof checkFnDetails == "function") {
    checkFnDetails = {
      fn: checkFnDetails,
      options: null,
    };
  } else if (typeof checkFnDetails == "string") {
    checkFnDetails = {
      fn: predefinedCheckFn[checkFnDetails],
      options: null,
    };
  } else if (
    typeof checkFnDetails == "object" &&
    typeof checkFnDetails.fn == "string"
  ) {
    checkFnDetails.fn = predefinedCheckFn[checkFnDetails.fn];
  }

  return yupLazy((value) =>
    checkFnDetails.fn(value, checkFnDetails.options)
      ? thenSchema.clone()
      : otherwiseSchema.clone()
  );
}
